import { render, staticRenderFns } from "./ignore-call-icon.vue?vue&type=template&id=5833fa6c"
import script from "./ignore-call-icon.vue?vue&type=script&lang=js"
export * from "./ignore-call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports